/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from '@material-ui/core';
import { AutoCompleteWithLabel } from 'commons/AutoComplete/AutoCompleteWithLabel';
import LocalizedText from 'commons/LocalizedText/LocalizedText';
import { TextFieldWithLabel } from 'commons/TextFieldWithLabel/TextFieldWithLabel';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '50px 0'
  },
  columnContainer: {
    paddingLeft: '50px'
  },
  title: {
    padding: '3px 10px',
    color: theme.palette.secondary.main,
    borderLeft: '5px solid',
    fontWeight: 'bold',
    fontSize: '120%'
  },
  countryAutoComplete: {
    minWidth: '300px',
    margin: 0,
    '& .MuiTextField-root': {
      marginTop: 0
    }
  }
}));

export const LaboratorySheet = ({
  changedFields, laboratoryInfo, isLoading, countries, handleOnChange,
  errorPhone, setErrorPhone, errorEmail, setErrorEmail, errorFax, setErrorFax
}) => {
  const classes = useStyles();
  const [country, setCountry] = useState('');

  const findCountryByRecid = recid => {
    return countries.find(country => country.recid === recid);
  };

  const findCountryByName = name => {
    return countries.find(country => country.countryName === name);
  };

  useEffect(() => {
    if(laboratoryInfo && !isLoading){
      setCountry(findCountryByRecid(laboratoryInfo.officialAddress.countryRecid).countryName);
    }
  },[laboratoryInfo, isLoading]);

  return (
    laboratoryInfo && (
      <Grid className={classes.container} container justifyContent='space-evenly' spacing={10}>
        <Grid item>
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <LocalizedText className={classes.title}>
                contactDetails
              </LocalizedText>
            </Grid>
            <Grid item>
              <Grid className={classes.columnContainer} container direction='column' spacing={1}>
                <TextFieldWithLabel
                  enableColorChangeOnModification
                  label='companyName'
                  onChange={value => handleOnChange(value, ['name'])}
                  startsModified={changedFields.includes('name')}
                  value={laboratoryInfo.name || ''}
                />
                <TextFieldWithLabel
                  enableColorChangeOnModification
                  error={errorEmail}
                  label='generalEmail'
                  onChange={value => handleOnChange(value, ['generalEmail'])}
                  setError={setErrorEmail}
                  startsModified={changedFields.includes('generalEmail')}
                  type="email"
                  value={laboratoryInfo.generalEmail || ''}
                />
                <TextFieldWithLabel
                  enableColorChangeOnModification
                  label='tvaNumber'
                  onChange={value => handleOnChange(value, ['tvaNumber'])}
                  startsModified={changedFields.includes('tvaNumber')}
                  value={laboratoryInfo.tvaNumber || ''}
                />
                <TextFieldWithLabel
                  enableColorChangeOnModification
                  error={errorPhone}
                  label='phone'
                  onChange={value => handleOnChange(value, ['phone'])}
                  setError={setErrorPhone}
                  startsModified={changedFields.includes('phone')}
                  type='phone'
                  value={laboratoryInfo.phone || ''}
                />
                <TextFieldWithLabel
                  enableColorChangeOnModification
                  error={errorFax}
                  label='fax'
                  onChange={value => handleOnChange(value, ['fax'])}
                  setError={setErrorFax}
                  startsModified={changedFields.includes('fax')}
                  type='fax'
                  value={laboratoryInfo.fax || ''}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction='column' spacing={1}>
            <Grid item>
              <LocalizedText className={classes.title}>
                address
              </LocalizedText>
            </Grid>
            <Grid item>
              <Grid className={classes.columnContainer} container direction='column' spacing={1}>
                <TextFieldWithLabel
                  enableColorChangeOnModification
                  label='addressLine1'
                  multiline
                  onChange={value => handleOnChange(value, ['officialAddress', 'addressLine1'])}
                  startsModified={changedFields.includes('addressLine1')}
                  value={laboratoryInfo.officialAddress.addressLine1 || ''}
                />
                <TextFieldWithLabel
                  enableColorChangeOnModification
                  label='addressLine2'
                  multiline
                  onChange={value => handleOnChange(value, ['officialAddress', 'addressLine2'])}
                  startsModified={changedFields.includes('addressLine2')}
                  value={laboratoryInfo.officialAddress.addressLine2 || ''}
                />
                <TextFieldWithLabel
                  enableColorChangeOnModification
                  label='postalCode'
                  onChange={value => handleOnChange(value, ['officialAddress', 'postalCode'])}
                  startsModified={changedFields.includes('postalCode')}
                  value={laboratoryInfo.officialAddress.postalCode || ''}
                />
                <TextFieldWithLabel
                  enableColorChangeOnModification
                  label='city'
                  onChange={value => handleOnChange(value, ['officialAddress', 'city'])}
                  startsModified={changedFields.includes('city')}
                  value={laboratoryInfo.officialAddress.city || ''}
                />
                <AutoCompleteWithLabel
                  className={classes.countryAutoComplete}
                  enableColorChangeOnModification
                  isLoading={isLoading}
                  label="country"
                  onChange={value => handleOnChange(findCountryByName(value).recid, ['officialAddress', 'countryRecid'])}
                  options={countries.map((p) => String(p.countryName))}
                  startsModified={changedFields.includes('countryRecid')}
                  value={country}
                  valueName="country"
                  variant='outlined'
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>)
  );
};